<div class="header-up">
  <div class="fixed">
    <ul class="menu-up">
      <li><a href="#" (click)="$event.preventDefault()">Home</a></li>
      <li><a href="#" (click)="$event.preventDefault()">About Us</a></li>
      <li><a href="#" (click)="$event.preventDefault()">Blog</a></li>
      <li><a href="#" (click)="$event.preventDefault()">Contact Us</a></li>
      <li>
        <a href="#" (click)="$event.preventDefault()"
          ><span class="icon ib-search"></span> Search</a
        >
      </li>
    </ul>
    <a class="phone-alphabet" href="#" (click)="$event.preventDefault()">
      <span class="icon ib-phone"></span> 1-877-ENTERTAIN<span>/</span>(368-3782)</a
    >
  </div>
</div>
<header class="header" role="banner">
  <div class="fixed">
    <ul class="menu-main-right">
      <li class="auth-item">
        <a class="btn btn-secondary" href="#" (click)="$event.preventDefault()">Sign In</a>
      </li>
      <li class="auth-item">
        <a class="btn btn-link" href="#" (click)="$event.preventDefault()">Sign Up</a>
      </li>
    </ul>
    <a
      id="menu-up-control"
      class="menu-up-control"
      [class.menu-up-control-is-close]="!menuOpen"
      [class.menu-up-control-is-open]="menuOpen"
      (click)="toggleMenu()"
    >
      <span class="icon ib-menu"></span><span class="icon ib-x"></span>
    </a>
    <a href="#" class="logo logo-ibranson" (click)="$event.preventDefault()">
      <img src="https://ibranson.com/img/ib-logo-30y.svg" alt="Ibranson" />
    </a>
    <div
      id="menu-general"
      class="menu-general"
      [class.menu-general-control-is-close]="!menuOpen"
      [class.menu-general-control-is-open]="menuOpen"
    >
      <div class="search-up">
        <form (submit)="$event.preventDefault()">
          <div class="form-group input-search">
            <input
              type="text"
              class="form-control"
              name="q"
              value=""
              placeholder="Start typing to search"
            />
          </div>
        </form>
      </div>
      <app-ib-nav [active]="active"></app-ib-nav>
      <div class="header-after-menu">
        <ul class="menu-up">
          <li><a href="#" (click)="$event.preventDefault()">Home</a></li>
          <li><a href="#" (click)="$event.preventDefault()">About Us</a></li>
          <li><a href="#" (click)="$event.preventDefault()">Blog</a></li>
          <li><a href="#" (click)="$event.preventDefault()">Contact Us</a></li>
          <li><a href="#" (click)="$event.preventDefault()">Terms of service</a></li>
          <li><a href="#" (click)="$event.preventDefault()">Locations</a></li>
          <li><a href="#" (click)="$event.preventDefault()">Privacy policy</a></li>
          <li><a href="#" (click)="$event.preventDefault()">Branson Missouri</a></li>
          <li>
            <a href="#" (click)="$event.preventDefault()"
              ><span class="icon ib-search"></span> Search</a
            >
          </li>
          <li><a href="#" (click)="$event.preventDefault()">Sign Up</a></li>
          <li><a href="#" (click)="$event.preventDefault()">Sign In</a></li>
        </ul>
        <a class="phone-alphabet" href="#" (click)="$event.preventDefault()">
          <span class="icon ib-phone"></span> 1-877-ENTERTAIN<span>/</span>(368-3782)</a
        >
      </div>
    </div>
  </div>
</header>
